module.exports = __webpack_public_path__ + "a1c99dffa99ac391817bde50be5a31d3.png";